import { permissions } from "../../config/permissions";
import { checkPermission } from "../../config/utils";

// Sent with the recommendation as `otto_validation_status`.
//
// There is no "not run" value, and its absence is the point. It existed for the case where the backend
// refused the caller, and that case used to pass silently — the save went through marked as never
// checked, and nothing told anyone. The endpoint now admits whoever may create a recommendation, so a
// refusal means something is genuinely broken rather than "not for you", and it is reported as
// INCOMPLETE like every other non-answer: visible, with the surveyor deciding whether to save.
//
// The flag being off is separate and writes no status at all (null) — nothing was asked, so there is
// nothing to report.
export const QA_VALIDATION_STATUS = {
    PASSED: "passed", // every applicable rule ran and found nothing, or there was nothing to check
    FAILED: "failed", // a rule reached a verdict and it was a finding
    INCOMPLETE: "incomplete", // Otto could not answer; the surveyor saw that and chose to save anyway
    OVERRIDDEN: "overridden" // a finding was reached and the surveyor saved anyway
};

// How long the clean result holds before the modal closes itself and the save proceeds.
export const QA_CLEAN_HOLD_MS = 2000;

// ...and how long it holds when NOTHING was actually compared — every applicable rule was skipped, so the
// screen is explaining why rather than reporting a result. Two seconds is right for a tick someone already
// expected; it is not enough to read a sentence they did not. The save still proceeds on its own: whether
// Otto could read a narrative must not decide whether a surveyor can record their work.
export const QA_NOTHING_CHECKED_HOLD_MS = 6000;

// Per-user switch under the `feature_flag` tab (FCA-7508). Absent reads as denied, per checkPermission's
// own default, so the flag has to be granted before the validation runs for anyone but super_admin.
export const isOttoValidationEnabled = () => checkPermission("feature_flag", permissions.RECOMMENDATION_OTTO_VALIDATION, "enable");
